import React, { useContext } from "react";
import { AppStore } from "src/Context/AppStore";
import styled from "styled-components";

const Container = styled.img<any>`
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  object-fit: contain;
`;

const Logo: React.SFC<any> = ({ height = "80px", width = "80px" }) => {
  const { company_logo } = useContext(AppStore);
  return <Container height={height} width={width} src={company_logo} />;
};

export default Logo;
